'use es6';

import { FetchCountryRequestTypes } from '../actions/CountryActions';
const initialState = null;

const Country = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchCountryRequestTypes.RECEIVE:
      return payload.data.country;

    default:
      return state;
  }
};

export default Country;